/**
 * @ignore
 * Created by daletan on 7/29/16.
 */

'use strict';

const _ = require('underscore');
const Backbone = require('dibs-backbone');
const SoaModel = require('../SoaModel');
const PriceLock = SoaModel.extend();
const Price = require('./Price.es');

_.extend(PriceLock, {
    LOCK_TYPE_ORIGINAL: 'ORIGINAL_PRICE',
    TYPE_RETAIL: 'RETAIL'
});

_.extend(PriceLock.prototype, {
    relations: [
        {
            key: 'price',
            relatedModel: Price,
            type: Backbone.One
        }
    ],
    getOriginalPriceIn(currency = 'USD') {
        const convertedAmounts = this.get('price.amount') || {};
        if (convertedAmounts) {
            return convertedAmounts.getAmountIn(currency);
        }
        return null;
    }
});


module.exports = PriceLock;



// WEBPACK FOOTER //
// ./~/bunsen/models/inventory/PriceLock.es.js